const UserHasPermission = {
  computed: {
    isSuperUser() {
      // super user = is in all privilege groups
      let isSuper = true;
      const { privilege_groups } = this.$store.state.auth.currentUser;

      Object.keys(privilege_groups).forEach((grp) => {
        if (!privilege_groups[grp]) {
          isSuper = false;
        }
      });

      return isSuper;
    },
  },
  methods: {
    userHasPermission(perm) {
      /**
       * If we don't have user object for any reason, grab it
       */
      if (!this.$store.state.auth.currentUser.privileges) {
        // TODO: In theory super admins should return true for every privilege,
        // but should we add a check in just in case?
        this.$store
          .dispatch("auth/listCurrentUser")
          .then(() => this.$store.state.auth.currentUser.privileges[perm]);
      } else {
        return this.$store.state.auth.currentUser.privileges[perm];
      }

      return false;
    },

    isInGroup(group) {
      let privilegeGroups;
      let myGroups;
      if (!this.$store.state.auth.currentUser.privileges) {
        this.$store.dispatch("auth/listCurrentUser").then(() => {
          privilegeGroups = this.$store.state.auth.currentUser.privilege_groups;
          myGroups = Object.keys(privilegeGroups).filter(
            (myGroup) => privilegeGroups[myGroup] === true
          );

          return myGroups.includes(group);
        });
      } else {
        privilegeGroups = this.$store.state.auth.currentUser.privilege_groups;
        myGroups = Object.keys(privilegeGroups).filter(
          (myGroup) => privilegeGroups[myGroup] === true
        );

        return myGroups.includes(group);
      }

      return false;
    },
  },
};

export default UserHasPermission;
